/* eslint-disable max-lines */
import { Form, Input, Select, Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { PlusButton } from 'src/components/common/PlusButton/PlusButton';
import { SearchPanel } from 'src/components/SearchPanel/SearchPanel';
import {
    SearchPanelFilterForm,
    SearchPanelFilterFormProps,
} from 'src/components/SearchPanel/SearchPanelFilterForm';
import { EntityLinks } from 'src/core/router/EntityLinks';
import { Router } from 'src/core/router/Router';
import {
    CampaignsFilter,
    CampaignsStore,
} from 'src/stores/CampaignsStore/CampaignsStore';
import { UserStore } from 'src/stores/UserStore/UserStore';
import styled from 'styled-components';

const store = CampaignsStore;

export const CampaignsPageHeaderPanel = observer(() => {
    const { t } = useTranslation();

    return (
        <StyledHeaderWrapper>
            <SearchPanel
                store={store}
                renderPanel={(props) => <FilterPanel {...props} />}
                placeholder={t('Page.Campaigns.AsideHeader.Search.Placeholder')}
            />
            {UserStore.can.manage.products && (
                <Tooltip
                    title={t('Page.Campaign.AsideHeader.CreateNewItem.Tooltip')}
                >
                    <PlusButton
                        onClick={() => {
                            const createLink = EntityLinks.campaigns.create?.();
                            createLink && Router.navigate(createLink);
                        }}
                    />
                </Tooltip>
            )}
        </StyledHeaderWrapper>
    );
});

const StyledHeaderWrapper = styled.header`
    position: relative;
    display: grid;
    grid-template-columns: 1fr auto;
`;

const FilterPanel = observer((props: SearchPanelFilterFormProps) => {
    const { t } = useTranslation();

    return (
        <SearchPanelFilterForm
            {...props}
            initialValues={{ issuedAt: [] }}
            onFinish={({ ...values }: CampaignsFilter) => {
                store.filterCriteria?.applyFilter({
                    ...values,
                });
                store.loadList();
            }}
        >
            <StyledSelect
                label={t('Page.Products.Filter.Status', {
                    defaultValue: 'Status',
                })}
                name="active"
            >
                <Select allowClear>
                    <Select.Option value="true">
                        {t(`data:status.product.ACTIVE`)}
                    </Select.Option>
                    <Select.Option value="false">
                        {t(`data:status.product.INACTIVE`)}
                    </Select.Option>
                </Select>
            </StyledSelect>
            <Form.Item
                label={t('Page.Products.Filter.MaxAmount', {
                    defaultValue: 'Max amount',
                })}
                name="maxAmount"
            >
                <StyledInput type="number" />
            </Form.Item>
            <Form.Item
                label={t('Page.Products.Filter.MaxTerm', {
                    defaultValue: 'Max term',
                })}
                name="maxTerm"
            >
                <StyledInput type="number" />
            </Form.Item>
        </SearchPanelFilterForm>
    );
});

const StyledSelect = styled(Form.Item)`
    .ant-select:not(.ant-select-customize-input) .ant-select-selector {
        display: flex;
        align-items: center;
        height: 2.7rem;
        border-radius: 0.5rem;
    }
`;

const StyledInput = styled(Input)`
    height: 2.7rem;
    border-radius: 0.5rem;
`;
